import styled from "styled-components";
import { colors } from "definitions";

export const YearContainer = styled.div`
  display: grid;
  justify-items: center;
  align-items: center;
`;

// El año seleccionado se distingue por peso, color y una línea inferior; el
// resto queda atenuado y se ilumina en hover.
export const YearItem = styled.button`
  font-family: inherit;
  font-size: ${(props) => (props.selected ? "3.2rem" : "2.2rem")};
  line-height: 4rem;
  font-weight: ${(props) => (props.selected ? 700 : 400)};
  color: ${(props) =>
    props.selected ? colors.fonts.yellowGreen : colors.fonts.darkGray};
  opacity: ${(props) => (props.selected ? 1 : 0.55)};
  background: none;
  border: none;
  border-bottom: 3px solid
    ${(props) => (props.selected ? colors.fonts.yellowGreen : "transparent")};
  padding: 0.4rem 1.2rem;
  margin-top: 0 !important;
  cursor: pointer;
  transition: color 0.2s ease, opacity 0.2s ease, font-size 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    opacity: 1;
    color: ${colors.fonts.yellowGreen};
  }
`;
